/**
 * Created by zhanghua on 2017/5/17.
 */
import VueHttpUtil from '../network/VueHttpUtil.js';
import AssistantBase from './AssistantBase'
import VueRouter from "vue-router";
import Vuex from "vuex";
import StoreConfig from "../../configs/StoreConfig";
export default class VueAssistant extends AssistantBase {

    static get instance() {
        if (!VueAssistant._instance)
            VueAssistant._instance = new VueAssistant();
        return VueAssistant._instance;
    }

    formatComponent(para)
    {
        // 组件生命周期处理
        para.beforeCreate = this.createVueBeforeCreateFunc(para.beforeCreate);
        para.created = this.createVueCreatedFunc(para.created)

        para.mounted = this.createVueMountedFunc(para.mounted);

        para.beforeRouteUpdate = this.createBeforeRouteUpdateFunc();

        para.beforeDestroy = this.createVueBeforeDestroy(para.beforeDestroy);
        para.destroyed = this.createVueDestroyedFunc(para.destroyed)

        para.data = para.data || {}
        para.methods = para.methods || {}
        para.events = para.events || {}
        para.computed = para.computed || {}

        if ( typeof para.data !== "function") {
            para.data = para.data || {}
            para.data.hadReuse = false
            para.data.hadInited = false
            para.data = this.createVueData(para.data)
            // console.log('=====para.data:===',para.data);
        }
    }

    createVueData(data) {
        return function () {
            return JSON.parse(JSON.stringify(data));
        }
    }

    createVueBeforeCreateFunc(funcs) {
        let assistant = this;
        funcs = funcs && ( Array.isArray(funcs) ? funcs : [funcs] ) || []
        return function (...paras) {
            let events = this.$options.events || {}
            Object.entries(events).forEach(([k,func])=>assistant.listen(k,this,func));
            funcs.forEach( f=>f.apply(this,paras) )
        }
    }

    createVueBeforeDestroy(funcs) {
        let assistant = this;
        funcs = funcs && ( Array.isArray(funcs) ? funcs : [funcs] ) || []
        return async function(...args){
            await this.$nextTick();
            this.hadInited = false;
            this.clear && this.clear(...args);
            funcs.forEach(func => func.apply(this, args))
        };
    }


    createVueCreatedFunc(funcs) {
        let assistant = this;
        funcs = funcs && ( Array.isArray(funcs) ? funcs : [funcs] ) || []
        return async function (...args) {
            assistant.allComponents.add(this);
            this.init && await this.init(...args);
            funcs.forEach(func => func.apply(this, args))
        }
    }

    createBeforeRouteUpdateFunc(){
        return async function (to, from, next) {
            next();

            this.clear && await this.clear();
            this.begin && await this.begin();
        }
    }

    createVueMountedFunc(funcs) {
        funcs = funcs && ( Array.isArray(funcs) ? funcs : [funcs] ) || []
        return async function (...args) {
            await this.$nextTick();
            this.begin && await this.begin(...args);
            funcs.forEach(func => func.apply(this, args))
        }
    }

    //创建初始化的init请求
    createInitRequestFunc(funcs) {
        funcs = funcs && ( Array.isArray(funcs) ? funcs : [funcs] ) || []
        return async function (...paras) {
            this.query = JSON.parse(JSON.stringify(this.$route.query));
            this.begin && await this.begin(...paras);
            await funcs.forEach(func=>func.apply(this, paras))
        }
    }

    createVueDestroyedFunc(funcs) {
        funcs = funcs && ( Array.isArray(funcs) ? funcs : [funcs] ) || []
        var assistant = this;
        return function (...args) {
            assistant.allComponents.delete(this)
            funcs.forEach(func => func.apply(this, args))
        }
    }

    configRouter(VueRouter,routerConfig) {
        var {config,defaultPath} = routerConfig;
        config.forEach(item=>{
            var url = item.path.replace(/\:.*$/gi,'').replace(/\/$/gi,'');
            var children = config.filter(cf=>cf.parent && cf.parent.replace(/\/$/gi,'') === url);
            if(children.length === 0)return;
            item.children = children;
        });

        var assistant = this;
        var root = config.filter(cf=>!cf.parent);

        defaultPath && root.push({path:'/',redirect:defaultPath});//自动跳转首页
        this._routerConfig = {mode:'history',base: process.env.BASE_URL,routes: root};

        var router = new VueRouter(this._routerConfig);
        this.router = router;
        // console.log('this._routerConfig====',this._routerConfig)

    }

    configStore(Vuex,StoreConfig){
        this.storeConfig = StoreConfig;
        this._store = new Vuex.Store(StoreConfig);
    }

    //创建notify事件
    createNotifyFunc() {
        return (...paras)=>this.notify(...paras)
    }

    config(Vue) {
        //一些组件级全局函数
        this._globalFunctions && Object.entries(this._globalFunctions).forEach( ([k,v])=>Vue.prototype[k]=v);
        Vue.prototype.notify = this.createNotifyFunc();

        if( this._networkConfig ){
            var invokeFunctionName = this._networkConfig.invokeFunctionName || 'sendRequest'
            this._networkHandler = this.formatNetWorkHandler(new VueHttpUtil());//new xxx($http);
            Vue.prototype[invokeFunctionName] = (...paras)=>this._networkHandler.sendHttpMessage(...paras);
        }

    }

}

